<template>
  <div>
    <Title :pages="[{ icon: 'store', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-card v-if="list_access">
        <v-card-title>
          <v-row align="center" class="mt-1">
            <v-col>
              <span>{{ page_title }}</span>
            </v-col>
            <v-spacer></v-spacer>
            <v-col>
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" single-line hide-details label="Buscar" density="compact"></v-text-field>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando...">
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.name }}</td>
              <td>{{ item.code }}</td>
              <td>{{ item.tms_service ? item.tms_service.tms_name : "Sin TMS asignado" }}</td>
              <td>{{ item.tms_service ? item.tms_service.url : "" }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { canalesVentasService } from "@/libs/ws/canalesVentasService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";

export default {
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      service: canalesVentasService,
      page_title: "Canales de venta",
      headers: [
        { title: "Canal de venta", align: "left", sortable: true, key: "name" },
        { title: "Codigo", align: "left", sortable: true, key: "code" },
        { title: "TMS asignado", align: "left", sortable: true, key: "tms_service.tms_name" },
        { title: "URL del TMS", align: "left", sortable: true, key: "tms_service.url" },
      ],
    };
  },
  mounted() {
    this.loadCanales();
  },
  methods: {
    // El endpoint devuelve el listado completo como array (sin paginacion del servidor)
    loadCanales() {
      this.loading = true;
      this.service
        .filter({ enable: true })
        .then((response) => {
          this.list = response.result || [];
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
